/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateSSOImageViewModel } from "../types/CreateSSOImageViewModel.ts";
import { ESSOCategorySchema } from "./ESSOCategorySchema.ts";
import { createSSOImageLangViewModelSchema } from "./createSSOImageLangViewModelSchema.ts";

export const createSSOImageViewModelSchema = z.object({
  title: z
    .string()
    .min(1)
    .max(250)
    .describe("Título da imagem SSO. Obrigatório. Máximo 250 caracteres."),
  categoryId: z
    .lazy(() => ESSOCategorySchema)
    .describe(
      "1 = Agribusiness | 2 = DataTech | 3 = Finance | 4 = Education | 5 = MarketingAndSales | 6 = Business | 7 = Law | 8 = HumanResources | 9 = ProjectManagement | 10 = General | ",
    ),
  dateStart: z
    .string()
    .datetime()
    .describe("Data de início da exibição da imagem SSO. Opcional.")
    .nullish(),
  dateEnd: z
    .string()
    .datetime()
    .describe("Data de término da exibição da imagem SSO. Opcional.")
    .nullish(),
  langs: z
    .array(z.lazy(() => createSSOImageLangViewModelSchema))
    .describe(
      "Lista de variações de idioma e viewport da imagem SSO. Obrigatório.",
    ),
}) as unknown as ToZod<CreateSSOImageViewModel>;
